import _objectSpread from "D:/Coding/help-doc/help-doc-front/help-doc-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import GHSeparator from "@/components/GHSeparator";
import { mapState } from "vuex";
export default {
  name: 'GHSubGroup',
  components: {
    GHSeparator: GHSeparator
    /*分隔线组件*/

  },
  data: function data() {
    return {
      flashingIconId: null,
      // 新增，用于控制抖动效果
      shakeTimeout: null // 新增，用于保存 setTimeout 的返回值

    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    current_tag: "current_tag",
    current_rhino_version: "current_rhino_version"
  })), {}, {
    filteredGroup: function filteredGroup() {
      var _this = this;

      return this.group.filter(function (comp) {
        return comp.is_enable && comp.rhino_versions.indexOf(_this.current_rhino_version) !== -1;
      });
    },
    hasVisibleIcons: function hasVisibleIcons() {
      return this.filteredGroup.length > 0;
    },
    layoutHeight: function layoutHeight() {
      // 确定实际行数是否大于零，如果不是，返回 '0px'，否则返回正确的高度
      return this.hasVisibleIcons ? "".concat(this.rows * 40, "px") : '0px';
    }
  }),
  props: {
    group: [Object],
    rows: Number
  },
  methods: {
    onClickComp: function onClickComp(id) {
      var _this2 = this;

      this.$emit("clickComp", id);
      this.stopShake(); // 新增，调用停止抖动方法

      this.flashingIconId = id; // 设置抖动图标 ID
      // 新增，保存setTimeout返回值到this.shakeTimeout

      this.shakeTimeout = setTimeout(function () {
        _this2.flashingIconId = null;
      }, 1000);
    },
    stopShake: function stopShake() {
      // 新增，立即停止抖动效果
      this.flashingIconId = null; // 新增，清除定时器

      if (this.shakeTimeout) {
        clearTimeout(this.shakeTimeout);
        this.shakeTimeout = null;
      }
    }
  }
};